import { colorLookup } from '@medifind/utils';

import { SVG } from './SVG';
const IconPhone = ({ color, size = 17 }) => {
  const colorCode = colorLookup(color) ?? colorLookup('blue');

  return (
    <SVG width={size} height={size} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17">
      <path stroke={colorCode} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 1.33L15.67 4 13 6.67M10.33 4h5.34" />
      <path
        stroke={colorCode}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15 11.95v2a1.33 1.33 0 0 1-1.45 1.33 13.2 13.2 0 0 1-5.76-2.05 13 13 0 0 1-4-4 13.2 13.2 0 0 1-2.04-5.78A1.33 1.33 0 0 1 3.07 2h2c.67 0 1.24.48 1.34 1.15.08.64.24 1.27.46 1.87.19.49.07 1.04-.3 1.4l-.84.85a10.67 10.67 0 0 0 4 4l.84-.84c.37-.37.92-.49 1.41-.3.6.22 1.23.38 1.87.46.67.1 1.17.68 1.15 1.36z"
        clipRule="evenodd"
      />
    </SVG>
  );
};

export { IconPhone as default, IconPhone };
